export enum MailAuthType {
    Basic,
    OAuth
}
